import ReactTooltip from "react-tooltip";
import { debounce } from "lodash";

const tooltipDebounce = 100;

export function scrollRebuild(){
	ReactTooltip.rebuild();
}

export const debouncedTooltipRebuild = debounce(scrollRebuild, tooltipDebounce);
